import { Observable, Subject } from 'rxjs/Rx';
import { TimeUnit, RandomUtil } from './../../util/index';
export class ToneEntry {
    constructor() {
        this.audioNodes = [];
        this.id = RandomUtil.generateId();
        this.frequency = "";
        this.delayAmount = "";
        this.delayUnit = TimeUnit.SECONDS;
        this.durationAmount = "";
        this.durationUnit = TimeUnit.SECONDS;
        this.oscillationType = "sine";
        this.volume = "100";
        this.pan = "0";
        this.started = false;
        this.ended = false;
        this.temp = false;
        this.onEnded = new Subject();
    }
    start(audioContext) {
        this.started = true;
        this.ended = false;
        let oscillatorNode = this.setupOscillatorNode(audioContext);
        let gainNode = this.setupGainNode(audioContext);
        let panNode = this.setupPanNode(audioContext);
        this.toneEndedSubscription = Observable.fromEvent(oscillatorNode, "ended")
            .subscribe(event => {
            this.ended = true;
            this.onEnded.next(null);
        }, err => {
            throw new Error(err);
        });
        oscillatorNode.connect(gainNode);
        gainNode.connect(panNode);
        panNode.connect(audioContext.destination);
        this.audioNodes.push(oscillatorNode);
        this.audioNodes.push(gainNode);
        this.audioNodes.push(panNode);
        return Observable.empty();
    }
    stop() {
        return Observable.from(this.audioNodes)
            .flatMap(node => {
            if (node.constructor.name == OscillatorNode.name)
                node.stop();
            node.disconnect();
            return Observable.empty();
        })
            .defaultIfEmpty(null)
            .do(Void => {
            this.toneEndedSubscription.unsubscribe();
            this.audioNodes = [];
            this.started = false;
        });
    }
    validate() {
        return !!Number(this.frequency) &&
            (this.delayAmount ? !!Number(this.delayAmount) : true) &&
            (this.durationAmount ? !!Number(this.durationAmount) : true);
    }
    setupOscillatorNode(audioContext) {
        let oscillatorNode = audioContext.createOscillator();
        oscillatorNode.type = this.oscillationType;
        oscillatorNode.frequency.value = Number(this.frequency);
        oscillatorNode.start(audioContext.currentTime + this.delayUnit.toSeconds(Number(this.delayAmount)));
        if (Number(this.durationAmount) > 0)
            oscillatorNode.stop(audioContext.currentTime + this.delayUnit.toSeconds(Number(this.delayAmount)) + this.durationUnit.toSeconds(Number(this.durationAmount)));
        return oscillatorNode;
    }
    setupGainNode(audioContext) {
        let gainNode = audioContext.createGain();
        gainNode.gain.value = Number(this.volume) / 100;
        return gainNode;
    }
    setupPanNode(audioContext) {
        let panNode = audioContext.createStereoPanner();
        panNode.pan.value = Number(this.pan);
        return panNode;
    }
}
//# sourceMappingURL=tone-entry.js.map